module.exports = __webpack_public_path__ + "media/pdf_missing/ciezarowy@3x-00a0d68a.svg";